module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00046-fs8.6bc67d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00046-fs8.png
// module id = 199
// module chunks = 0